import React, { useEffect, useState } from 'react'
import { BreadCrumb, HorizontalLoader } from 'Components'
import './Payroll.scss'
import { CurrencyFormatter } from 'Helpers'
import * as yup from 'yup'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { useResolvedProfile } from 'Hooks/useResolvedProfile'
import { salaryService } from 'Services/salaryService'
import { CurrencyFormatter2 } from 'Helpers/CurrencyFormatter2'
import Swal from 'sweetalert2'

type PayrollItem = {
  category: string
  amount: number
}

export type PayrollUpdate = {
  bankName?: string
  bankAccountNumber?: string
  pfa?: string
  rsaNumber?: string
  taxId?: string
  state?: string
  allowance?: number
  salary?: number
  earnings?: PayrollItem[]
  allowances?: PayrollItem[]
  deductions?: PayrollItem[]
  relief?: PayrollItem[]
}

const schema = yup.object().shape({
  bankName: yup.string(),
  bankAccountNumber: yup.string(),
  pfa: yup.string(),
  rsaNumber: yup.string(),
  taxId: yup.string(),
  state: yup.string(),
  allowance: yup.number(),
  salary: yup.number(),
})

function Payroll() {
  //   const { profile } = useResolvedProfile()
  const {
    handleSubmit,
    register,
    reset,
    setValue,
    formState: { errors },
  } = useForm<PayrollUpdate>({
    resolver: yupResolver(schema),
  })

  const [netPay, setNetPay] = useState<number>()
  const [basicEarnings, setBasicEarnings] = useState<number>()
  const [leaveAllowance, setLeaveAllowance] = useState<number>()
  const [salaryValue, setSalaryValue] = useState('')
  const [leaveValue, setLeaveValue] = useState('')
  const [salaryData, setSalaryData] = useState<any>(null)
  const [loading, setLoading] = useState<boolean>(false)

  const getSalary = async () => {
    setLoading(true)
    try {
      const response = await salaryService.getEmployeeSalary()

      const dataset = response.data.data ?? []

      const firstRow = dataset
      setSalaryData(dataset)

      const earning = firstRow?.earnings ?? []
      const deduction = firstRow?.deductions ?? []
      const allowance = firstRow?.allowances ?? []

      const totalEarnings = earning.reduce(
        (sum: number, item: { amount: number }) => sum + (item.amount || 0),
        0,
      )

      const totalDeductions = deduction.reduce(
        (sum: number, item: { amount: number }) => sum + (item.amount || 0),
        0,
      )

      setNetPay(totalEarnings - totalDeductions)

      const basic = earning.find((item: any) => item.category === 'Basic Salary')
      const leave = allowance.find((item: any) => item.category === 'Leave Allowance')

      setBasicEarnings(basic?.amount ?? 0)
      setLeaveAllowance(leave?.amount ?? 0)
    } catch (error) {
      console.error('getSalary error', error)
      setNetPay(0)
      setBasicEarnings(0)
      setLeaveAllowance(0)
    } finally {
      setLoading(false)
    }
  }
  useEffect(() => {
    getSalary()
  }, [])

  const [request, setRequest] = useState(false)

  const submitEmployeeDeatils = async (data: PayrollUpdate) => {
    setRequest(true)
    try {
      // const updatedEarnings = salaryData.earnings.map((item: any) => {
      //   if (item.category === 'Basic Salary') {
      //     return { ...item, amount: data.salary }
      //   }
      //   return item
      // })

      // const updatedAllowances = [
      //   ...(salaryData.allowances || []).filter((a: any) => a.category !== 'Leave Allowance'),
      //   {
      //     category: 'Leave Allowance',
      //     amount: data.allowance,
      //   },
      // ]

      const earnings = earningsState
        .filter((item) => item.amount !== null && item.amount !== 0)
        .map((item) => ({
          category: item.category,
          amount: item.amount,
        }))
      const allowances = allowancesState
        .filter((item) => item.amount !== null && item.amount !== 0)
        .map((item) => ({
          category: item.category,
          amount: item.amount,
        }))
      const deductions = deductionsState
        .filter((item) => item.amount !== null && item.amount !== 0)
        .map((item) => ({
          category: item.category,
          amount: item.amount,
        }))
      const relief = refliefsState
        .filter((item) => item.amount !== null && item.amount !== 0)
        .map((item) => ({
          category: item.category,
          amount: item.amount,
        }))

      //   const payload = {
      //     userId: profile?.id,
      //     earnings,
      //     allowances,
      //     deductions,
      //     relief,
      //   }

      //   const res = await salaryService.createSalary(payload)

      //   if (res.data.status === true) {
      //     Swal.fire({
      //       text: `${profile?.firstName} payroll information updated succesfully`,
      //       icon: 'success',
      //       confirmButtonText: 'Ok',
      //     })
      //   } else {
      //     const swalWithBootstrapButtons = Swal.mixin({
      //       customClass: {
      //         cancelButton: 'btn btn-danger',
      //       },
      //       buttonsStyling: false,
      //     })

      //     swalWithBootstrapButtons.fire({
      //       title: 'Oops!',
      //       text: 'Something went wrong!',
      //       icon: 'warning',
      //       showCancelButton: true,
      //       showConfirmButton: false,
      //       cancelButtonText: 'close',
      //       reverseButtons: true,
      //     })
      //   }
    } catch (error: any) {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          cancelButton: 'btn btn-danger',
        },
        buttonsStyling: false,
      })

      swalWithBootstrapButtons.fire({
        title: 'Oops!',
        text: error.response.data.error,
        icon: 'warning',
        showCancelButton: true,
        showConfirmButton: false,
        cancelButtonText: 'close',
        reverseButtons: true,
      })
    } finally {
      setRequest(false)
    }
  }

  useEffect(() => {
    reset({
      allowance: leaveAllowance,
      salary: basicEarnings,
    })
  }, [basicEarnings, leaveAllowance, reset])

  useEffect(() => {
    if (basicEarnings !== undefined && leaveAllowance !== undefined) {
      setSalaryValue(CurrencyFormatter(basicEarnings))
      setLeaveValue(CurrencyFormatter(leaveAllowance))
    }
  }, [basicEarnings, leaveAllowance])

  // new
  const earningCategories = [
    { category: 'Basic Salary', active: false, amount: null },
    { category: 'Housing Allowance', active: false, amount: null },
    { category: 'Transport Allowance', active: false, amount: null },
    { category: 'Utilities', active: false, amount: null },
    { category: 'COLA', active: false, amount: null },
  ]
  //
  const deductionCategories = [
    { category: 'PAYE Tax', active: false, amount: null },
    { category: 'Pension', active: false, amount: null },
    { category: 'Staff Loan', active: false, amount: null },
    { category: 'Other Deductions', active: false, amount: null },
  ]

  const allowanceCategories = [
    { category: 'Leave Allowance', active: false, amount: null },
    { category: 'Bonus', active: false, amount: null },
    { category: 'Commission', active: false, amount: null },
    { category: 'Expense Allowance', active: false, amount: null },
    { category: 'Others', active: false, amount: null },
  ]

  const reliefCategories = [{ category: 'Rent Relief', active: false, amount: null }]

  const [earningsState, setEarningsState] = useState<any[]>([])
  const [allowancesState, setAllowancesState] = useState<any[]>([])
  const [deductionsState, setDeductionsState] = useState<any[]>([])
  const [refliefsState, setReliefsState] = useState<any[]>([])

  // merge FE/API cat
  const mergeCategories = (
    defaults: { category: string; amount: number | null }[],
    apiData: { category: string; amount: number }[] = [],
  ) => {
    return defaults.map((item) => {
      const isFound = apiData.find((d) => d.category === item.category)

      return isFound ? { ...item, amount: isFound.amount } : item
    })
  }

  useEffect(() => {
    if (!salaryData) {
      setEarningsState(earningCategories)
      setAllowancesState(allowanceCategories)
      setDeductionsState(deductionCategories)
      setReliefsState(reliefCategories)
      return
    }

    setEarningsState(mergeCategories(earningCategories, salaryData.earnings))

    setAllowancesState(mergeCategories(allowanceCategories, salaryData.allowances))

    setDeductionsState(mergeCategories(deductionCategories, salaryData.deductions))

    setReliefsState(mergeCategories(reliefCategories, salaryData.relief))
  }, [salaryData])

  const handleAmountChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number,
    state: any[],
    setState: React.Dispatch<React.SetStateAction<any[]>>,
  ) => {
    const raw = e.target.value.replace(/,/g, '')

    const updated = [...state]

    if (raw === '') {
      updated[index].amount = null
      setState(updated)
      return
    }

    if (!isNaN(Number(raw))) {
      updated[index].amount = Number(raw)
      setState(updated)
    }
  }

  //   useEffect(() => {
  //     if (profile) {
  //       reset({
  //         bankName:
  //           profile?.bankName === null || profile?.bankName === 'string' ? '' : profile?.bankName,
  //         bankAccountNumber:
  //           profile?.bankAccountNumber === null || profile?.bankAccountNumber === 'string'
  //             ? ''
  //             : profile?.bankAccountNumber,
  //         pfa: profile?.pfa === null || profile?.pfa === 'string' ? '' : profile?.pfa,
  //         rsaNumber:
  //           profile?.rsaNumber === null || profile?.rsaNumber === 'string' ? '' : profile?.rsaNumber,
  //         taxId: profile?.taxId === null || profile?.taxId === 'string' ? '' : profile?.taxId,
  //         state: profile?.state === null || profile?.state === 'string' ? '' : profile?.state,
  //       })
  //     }
  //   }, [profile, reset])

  return (
    <div className='edit-payrol'>
      <div className='container crumb'>
        <BreadCrumb
          title={'Profile Details'}
          parent={'Profile'}
          parentUrl={'profile'}
          showTitle={false}
        ></BreadCrumb>
      </div>
      <form onSubmit={handleSubmit(submitEmployeeDeatils)}>
        <div className='main-content'>
          <h6 className='title'>Payroll & Statutory Details</h6>
          {loading ? (
            <HorizontalLoader />
          ) : (
            <div className='container-fluid m-0 p-0 salaryAllowance'>
              <div className='row'>
                <div className='col-lg-6 d-fle flex-column gap-4'>
                  <h6 className='text-uppercase mb-3'>Earnings</h6>

                  {earningsState.map((item, index) => (
                    <div className='form-group mb-3' key={index}>
                      <label>{item?.category}</label>

                      <input
                        disabled
                        type='text'
                        className='form-control not-allowed-clean'
                        value={
                          item.amount !== null && item.amount !== undefined
                            ? CurrencyFormatter2(item?.amount)
                            : ''
                        }
                        onChange={(e) =>
                          handleAmountChange(e, index, earningsState, setEarningsState)
                        }
                      />
                    </div>
                  ))}

                  <h6 className='text-uppercase mb-3 mt-4'>Allowances</h6>

                  {allowancesState.map((item, index) => (
                    <div className='form-group mb-3' key={index}>
                      <label>{item?.category}</label>

                      <input
                        disabled
                        type='text'
                        className='form-control not-allowed-clean'
                        value={
                          item.amount !== null && item.amount !== undefined
                            ? CurrencyFormatter2(item.amount)
                            : ''
                        }
                        onChange={(e) =>
                          handleAmountChange(e, index, allowancesState, setAllowancesState)
                        }
                      />
                    </div>
                  ))}
                </div>

                <div className='col-lg-6 d-fle flex-column gap-4'>
                  <h6 className='text-uppercase mb-3'>Deductions</h6>

                  {deductionsState.map((item, index) => (
                    <div className='form-group mb-3' key={index}>
                      <label>{item?.category}</label>

                      <input
                        disabled
                        type='text'
                        className='form-control not-allowed-clean'
                        value={
                          item.amount !== null && item.amount !== undefined
                            ? CurrencyFormatter2(item.amount)
                            : ''
                        }
                        onChange={(e) =>
                          handleAmountChange(e, index, deductionsState, setDeductionsState)
                        }
                      />
                    </div>
                  ))}

                  <h6 className='text-uppercase mb-3 mt-4'>Reliefs</h6>

                  {refliefsState.map((item, index) => (
                    <div className='form-group mb-3' key={index}>
                      <label>{item?.category}</label>

                      <input
                        disabled
                        type='text'
                        className='form-control not-allowed-clean'
                        value={
                          item.amount !== null && item.amount !== undefined
                            ? CurrencyFormatter2(item.amount)
                            : ''
                        }
                        onChange={(e) =>
                          handleAmountChange(e, index, refliefsState, setReliefsState)
                        }
                      />
                    </div>
                  ))}
                </div>

                {/* <div className='card'>
                  <div className='card-body d-flex justify-content-between mt-2'>
                    <div className='salary'>
                      <h6>Base Salary</h6>
                      <div className='d-flex align-items-center'>
                        <span className='naira'>₦</span>
                        <input
                          type='text'
                          className='form-control m-0 p-0'
                          value={salaryValue}
                          onChange={(e) => {
                            const raw = e.target.value.replace(/,/g, '')

                            if (!isNaN(Number(raw))) {
                              const numeric = Number(raw)

                              setSalaryValue(CurrencyFormatter2(numeric))
                              setValue('salary', numeric, {
                                shouldValidate: true,
                                shouldDirty: true,
                              })
                            }
                          }}
                        />
                      </div>
                      {errors.salary && <div className='text-danger'>{errors.salary.message}</div>}
                    </div>
                  </div>
                </div>
                <div className='card'>
                  <div className='card-body mt-2'>
                    <div className='salary'>
                      <h6>Leave Allowance</h6>
                      <div className='d-flex align-items-center'>
                        <span className='naira'>₦</span>
                        <input
                          type='text'
                          className='form-control m-0 p-0'
                          value={leaveValue}
                          onChange={(e) => {
                            const raw = e.target.value.replace(/,/g, '')

                            if (!isNaN(Number(raw))) {
                              const numeric = Number(raw)

                              setLeaveValue(CurrencyFormatter2(numeric))
                              setValue('allowance', numeric, {
                                shouldValidate: true,
                                shouldDirty: true,
                              })
                            }
                          }}
                        />
                        {errors.allowance && (
                          <div className='text-danger'>{errors.allowance.message}</div>
                        )}
                      </div>
                    </div>
                  </div>
                </div> */}
                <div className='form-group mt-4 btn-wrapper d-none'>
                  <button className='btn btn-default-2 w-100' disabled={request}>
                    Save Details{' '}
                    {request && <span className='spinner-border spinner-border-sm'></span>}
                  </button>
                </div>

                <div className='col-lg-6 d-fle flex-column gap-4 d-none'>
                  <h6 className='text-uppercase mb-3'>bank details</h6>

                  <div className='form-group mb-3'>
                    <label htmlFor='price-per-lit'>Account Number</label>
                    <input
                      disabled
                      placeholder='Account Number'
                      type='text'
                      id='bankAccountNumber'
                      className='form-control'
                      {...register('bankAccountNumber')}
                    />
                    {errors.bankAccountNumber && (
                      <div className='text-danger'>{errors.bankAccountNumber.message}</div>
                    )}
                  </div>

                  <div className='form-group mb-4'>
                    <label htmlFor='Bank'>Bank</label>
                    <select
                      disabled
                      id='bank'
                      defaultValue=''
                      className='form-control'
                      {...register('bankName')}
                    >
                      <option disabled value=''>
                        --Select Bank--
                      </option>
                      <option value='uba'>United Bank of Africa</option>
                      <option value='zenith'>Zenith Bank Plc</option>
                      <option value='union'>Union Bank</option>
                    </select>
                    {errors.bankName && (
                      <div className='text-danger'>{errors.bankName.message}</div>
                    )}
                  </div>

                  <h6 className='text-uppercase mb-3'>Pension Details</h6>

                  <div className='form-group mb-3'>
                    <label htmlFor='price-per-lit'>RSA Number</label>
                    <input
                      disabled
                      placeholder='RSA Number'
                      type='text'
                      id='rsaNumber'
                      className='form-control'
                      {...register('rsaNumber')}
                    />
                    {errors.rsaNumber && (
                      <div className='text-danger'>{errors.rsaNumber.message}</div>
                    )}
                  </div>
                  <div className='form-group mb-4'>
                    <label htmlFor='pfa'>PFA</label>
                    <select
                      disabled
                      id='pfa'
                      defaultValue=''
                      className='form-control'
                      {...register('pfa')}
                    >
                      <option disabled value=''>
                        --Select PFA--
                      </option>
                      <option value='ibtc'>Stanbic IBTC Pension Managers</option>
                      <option value='tp'>Trustfund Pensions Plc</option>
                      <option value='ppl'>Premium Pension Limited</option>
                    </select>
                    {errors.pfa && <div className='text-danger'>{errors.pfa.message}</div>}
                  </div>

                  <h6 className='text-uppercase mb-3'>Tax Details</h6>

                  <div className='form-group mb-3'>
                    <label htmlFor='price-per-lit'>Tax ID</label>
                    <input
                      disabled
                      placeholder='Tax ID'
                      type='text'
                      id='taxNumber'
                      className='form-control'
                      {...register('taxId')}
                    />
                    {errors.taxId && <div className='text-danger'>{errors.taxId.message}</div>}
                  </div>

                  <div className='form-group mb-3'>
                    <label htmlFor='state'>Residential State</label>
                    <select
                      disabled
                      id='state'
                      defaultValue=''
                      className='form-control'
                      {...register('state')}
                    >
                      <option disabled value=''>
                        --Select State--
                      </option>
                      <option value='lagos'>Lagos</option>
                      <option value='kwara'>Kwara</option>
                      <option value='ogun'>Ogun</option>
                    </select>
                    {errors.state && <div className='text-danger'>{errors.state.message}</div>}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </form>
    </div>
  )
}

export default Payroll
